import React, { useState } from 'react';
import { CustomModal } from '../../../common/ui/CustomModal';
import { drapcodeIcon } from '../../../common/custom/icon-library';
import FormFieldWithLabel from '../../common/FormFieldWithLabel';
import CustomSelect from '../../../common/formElements/CustomSelect';
import { Form, Formik } from 'formik';

export const EventsModal = ({ isOpen, handleToggle, events, insertTextToParamInput }) => {
  const [eventType, setEventType] = useState('');
  const [eventName, setEventName] = useState('');

  const eventTypeOptions = [{ label: 'OnClick', value: 'onclick' }];
  const eventsOptions =
    events && events.length
      ? events.map((event) => ({
          value: event.eventName,
          label: event.eventTitle,
        }))
      : [];

  const toggle = () => {
    setEventType('');
    setEventName('');
    handleToggle();
  };

  return (
    <CustomModal
      isOpen={isOpen}
      toggle={toggle}
      size="lg"
      header={
        <div
          className="d-flex justify-content-between align-items-center"
          style={{ width: '45rem' }}
        >
          <strong>Add Events</strong>
        </div>
      }
      body={
        <Formik enableReinitialize={true} initialValues={{}}>
          {({ isSubmitting, values, setFieldValue, setFieldTouched, errors }) => (
            <Form>
              <div className="row">
                <div className="col-12">
                  <div className="form-group">
                    <FormFieldWithLabel cta={false} label="Event Type" icon="select">
                      <CustomSelect
                        name={'eventType'}
                        isMulti={false}
                        onChange={setFieldValue}
                        onBlur={setFieldTouched}
                        options={eventTypeOptions}
                        value={eventType}
                        placeholder={'Event Type'}
                        onChangeValue={(name, value) => setEventType(value)}
                      />
                    </FormFieldWithLabel>
                  </div>
                </div>
                <div className="col-12">
                  <div className="form-group">
                    <FormFieldWithLabel cta={false} label="Event" icon="select">
                      <CustomSelect
                        name={'Event'}
                        isMulti={false}
                        onChange={setFieldValue}
                        onBlur={setFieldTouched}
                        options={eventsOptions}
                        value={eventName}
                        placeholder={'Event'}
                        onChangeValue={(name, value) => setEventName(value)}
                      />
                    </FormFieldWithLabel>
                  </div>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      }
      footer={
        <div className="col-md-12 col-lg-12 mt-4 text-right">
          <button
            type="button"
            className="btn btn-md btn-theme-submit"
            title="Insert Event"
            onClick={() => {
              insertTextToParamInput(
                `${eventType ? `${eventType}="${eventName}(event)"` : `${eventName}(event)`}`,
                'Link Inserted',
              );
              toggle();
            }}
          >
            <i className={`wb ${drapcodeIcon('add')}`}></i>&nbsp;Insert
          </button>
        </div>
      }
    />
  );
};
